import { useClientPortalAPI } from "@certn/api";
import { Avatar, Picker, SelectChip } from "@certn/cascadia-react";
import { parseName } from "@certn/utils";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";
import { useUser } from "../../../hooks/useUser";
import { sortPickerItems } from "../../../utils/sortPickerItems";

interface Props {
  caseId: string;
}

export function ActorFilter(props: Props) {
  const { caseId } = props;
  const { setParam, params } = useQueryParams();
  const { data } = useClientPortalAPI(
    `/api/internal/client-portal/case/${caseId}/activity-log/actors/`
  );

  const { t } = useTranslation();
  const { details: userDetails } = useUser();

  const pickerItems = sortPickerItems({
    data: data?.results,
    userDetails,
    includeAvatar: false,
    useIdAsKey: true,
    t,
  });

  // Determines if Certn in in the initial list and puts it at the 2nd spot in the array
  if (data?.results.some((obj) => obj.auth0_id === "Certn"))
    pickerItems.splice(1, 0, {
      id: "Certn",
      name: "Certn",
      leading: false,
      full_name: "Certn",
    });

  return (
    <Picker
      label={t("Actioned by")}
      selectedKeys={params.actor?.split(",") || []}
      onSelectionChange={(keys) => setParam("actor", Array.from(keys))}
      selectionMode="multiple"
      items={pickerItems}
      showActionBar
      testID="actor-picker"
      trigger={function (props) {
        if (props.selectedItems.length === 1) {
          return (
            <SelectChip
              avatar={
                <Avatar
                  name={parseName(props.selectedItems[0].full_name)}
                  size="x-small"
                />
              }
              isSelected
              testID={props.testID}
            >
              {props.selectedItems[0].name}
            </SelectChip>
          );
        }
        return (
          <SelectChip
            badge={props.count ? String(props.count) : undefined}
            testID={props.testID}
          >
            {props.label}
          </SelectChip>
        );
      }}
    />
  );
}
